import { storageKeys } from '@/shared/consts/storageKeys'

export const buildStorageService = (storage: Storage) => {
  const _buildKeyWithPrefix = (key = '') => {
    return `${storageKeys.prefix}${key}`
  }

  const getItem = (key = '') => {
    return storage.getItem(_buildKeyWithPrefix(key))
  }

  const setItem = (key = '', value = '') => {
    storage.setItem(_buildKeyWithPrefix(key), value)
  }

  const removeItem = (key = '') => {
    return storage.removeItem(_buildKeyWithPrefix(key))
  }

  return {
    getItem,
    removeItem,
    setItem
  }
}
